export const STORE_TYPES = [
    { title: 'Source', value: 'source' },
    { title: 'Destination', value: 'destination' }
];
